export default "__VITE_ASSET__BxLV_TJv__"